import mapActions from './mapActions';

export default mapActions('buildings_with_performances', {
    fetchAll_url: () => '/api/buildings_with_performances'
});